export default __webpack_public_path__ + "static/media/tiktok.01ce59e1.svg";